// Rich text editors leave markup like "<p><br></p>" behind after a focus, so an
// untouched editor must not count as entered data.
const stripHtml = (value) =>
    String(value).replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');

const hasValue = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'boolean') return value;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object') return true; // dayjs date, File, select object
    return stripHtml(value).trim() !== '';
};

/**
 * True when the user has entered anything worth warning about before leaving.
 * Pass only user-editable values — not option lists or preset defaults, which
 * would make the form look dirty the moment it mounts.
 */
export const hasAnyValue = (values = []) => values.some(hasValue);

export default hasAnyValue;
